import { styled } from '@linaria/react';
import { animated } from 'react-spring';

function Box({ size = 80, extra, style, children }) {
  return (
    <Wrapper>
      <Outline />
      <VisibleBox
        style={{
          background: extra
            ? 'var(--color-gray-500)'
            : 'var(--color-primary)',
          opacity: extra ? 1 : 0.8,
          ...style,
        }}
      >
        {children}
      </VisibleBox>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
`;

const Outline = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 4px dashed var(--color-gray-500);
`;

const VisibleBox = styled(animated.div)`
  position: relative;
  width: 100%;
  height: 100%;
  background: var(--color-primary);
  opacity: 0.8;
  display: grid;
  place-content: center;
  color: white;
  will-change: transform;
`;

export default Box;
